import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as validationService from "../add-device-modal/validationService";

function HostNameField({ value, onChange, error, disabled }) {

    useEffect(() => {
        validationService.validateHostName(value, 'hostName')
        return () => validationService.cleanValidation('hostName');
    }, [value])

    const [touched, setTouched] = useState(false);

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="hostname">Hostname <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${(error && touched) && 'border-danger'}`}
                    id="hostname"
                    value={value}
                    disabled={disabled}
                    onFocus={() => setTouched(true)}
                    onChange={disabled ? null : event => onChange(event.target.value)} />
                {/* onChange={event => onChange(event.target.value)}/> */}
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("HostNameField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.hostName
    }
}

export default connect(mapStateToProps)(HostNameField);
